import axios from "@/plugins/axios";

const getAll = (params) => {
  return axios.get('/review', { params })
}

const getPendingReviews = (params) => {
  return axios.get('/review/pending', { params })
}

const getStats = (params) => {
  return axios.get('/review/stats', { params })
}

const getChartData = (params) => {
  return axios.get('/review/chart', { params })
}

const getOne = (id) => {
  return axios.get(`/review/${id}`)
}

const reply = (id, data) => {
  return axios.post(`/review/${id}/reply`, data)
}

const update = (id, data) => {
  return axios.put(`/review/${id}`, data)
}

const approve = (id) => {
  return axios.put(`/review/${id}/approve`)
}

const disapprove = (id) => {
  return axios.put(`/review/${id}/disapprove`)
}

const ignore = (id) => {
  return axios.put(`/review/${id}/ignore`)
}

const deleteReply = (id) => {
  return axios.post(`/review/${id}/delete-reply`)
}

const getReportData = () => {
  return axios.get(`/review/report`)
}

const exportReport = (data) => {
  return axios.post(`/review/report/export`, data)
}

const exportReviews = (data) => {
  return axios.post(`/review/export`, data, { responseType: 'blob' })
}

const getWords = (params) => {
  return axios.get('/review/words', { params });
}

const approveBulk = async (data) => {
  try {
      const response = await axios.post(`/review/approve-bulk`, data);
      return response;
  } catch (error) {
      console.error("API Call Failed:", error.response ? error.response.data : error);
      throw error;
  }
};

const disapproveBulk = async (data) => {
  try {
      const response = await axios.post(`/review/disapprove-bulk`, data); // 🔥 Changed to POST
      return response;
  } catch (error) {
      console.error("API Call Failed:", error.response ? error.response.data : error);
      throw error;
  }
};

export default {
  getAll,
  getPendingReviews,
  getOne,
  reply,
  update,
  approve,
  disapprove,
  ignore,
  deleteReply,
  getReportData,
  exportReport,
  exportReviews,
  getStats,
  getChartData,
  approveBulk,
  disapproveBulk,
  getWords,
}